import tracker from 'sanitas-tracking'

const TRIGGER_ACTION = 'TRACKER_TRIGGER_ACTION'

export default {
  trackAction(rule, payload) {
    const language = document.documentElement.getAttribute('lang')
    const host = window.location.origin
    const url = host + window.location.pathname.replace(/(.*)\/$/, '$1')

    const data = {
      page: {
        url,
        aliasUrl: host,
        language,
      },
      survey: payload,
    }

    tracker.set({ data })
    tracker.trigger(TRIGGER_ACTION, rule)
  },
}
